import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const { Form } = Common;

const ImportReImportModal = ({
  handleClose,
  handleAccept,
  handleSelectHeaders,
  isOpened,
  modulo,
  t,
}) => (
  <Common.Modal show={isOpened} handleClose={handleClose} keyboard={false}>
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLongTitle">
          {t('import.reimport_title')}
        </h5>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div
        className="modal-body"
        dangerouslySetInnerHTML={{
          __html: t('import.reimport', { name: modulo }),
        }}
      />
      <div className="modal-footer">
        <Form.Button
          type="button"
          className="btn btn-secondary"
          text={t('actions.cancel')}
          onClick={handleClose}
        />

        <Form.Button
          type="button"
          className="btn btn-warning"
          text={t('import.fields.selectHeaders')}
          onClick={handleSelectHeaders}
        />

        <Form.Button
          type="button"
          className="btn btn-warning"
          text={t('actions.confirm')}
          onClick={handleAccept}
        />
      </div>
    </div>
  </Common.Modal>
);

ImportReImportModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleAccept: PropTypes.func.isRequired,
  handleSelectHeaders: PropTypes.func.isRequired,
  isOpened: PropTypes.bool.isRequired,
  modulo: PropTypes.object,
  t: PropTypes.func.isRequired,
};

export default translate()(ImportReImportModal);



// WEBPACK FOOTER //
// src/modules/secured/modules/import/components/list/ImportReImportModal.js